<template>
    <b-modal
        :id="'assignment-part-editor-blueprint-upload-modal-' + id"
        :ref="'assignment-part-editor-blueprint-upload-modal-' + id"
        :title="$t('common.upload')"
        :ok-title="$t('common.upload')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-disabled="disabled"
        @close="onClose()"
        @ok="assignmentBlueprintUpload"
        modal-class="apprentice-default-modal">
        <div class="editor-file-upload">
            <b-alert
                show
                variant="danger">
                {{
                    $t(
                        'group.internship.make_sure_no_one_is_working_in_the_editor_if_a_file_is_uploaded_while_someone_is_in_the_editor_work_may_be_lost',
                    )
                }}
            </b-alert>

            <div class="file">
                <form
                    @submit.prevent="assignmentBlueprintUpload"
                    method="post"
                    enctype="multipart/form-data">
                    <b-form-file
                        class="apprentice-file-upload"
                        v-model="file"
                        name="file"
                        :placeholder="$t('upload.placeholder_word_excel_ppt')"
                        :drop-placeholder="$t('upload.placeholder_word_excel_ppt')"
                        :browse-text="$t('upload.choose_file')">
                    </b-form-file>
                    <input
                        type="hidden"
                        name="_token"
                        :value="csrfToken" />
                    <input
                        v-if="groupId"
                        type="hidden"
                        name="group_id"
                        :value="groupId" />
                </form>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-part-editor-upload-blueprint-modal-component',
    props: ['id', 'groupId'],
    data() {
        return {
            file: null,
        };
    },
    methods: {
        assignmentBlueprintUpload() {
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('group_id', this.groupId);
            const headers = { 'Content-Type': 'multipart/form-data' };
            this.alert.saving(this.$t('common.upload'), this.$t('upload.file_being_uploaded'));
            this.axios.post(this.routes.assignmentPartEditorBlueprintUpload(this.id), formData, { headers }).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    if (error.response.status === 422) {
                        this.alert.notice(this.$t('components.upload_failed'), error.response.data.msg);
                    } else {
                        this.alert.ajaxError(error);
                    }
                },
            );
        },
        onClose() {
            this.file = null;
        },
    },
    computed: {
        disabled() {
            return !this.file;
        },
    },
    created() {
        this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    },
};
</script>

<style scoped></style>
